import { NgModule } from '@angular/core';

import { DurationTimePipe } from './pipes/duration-time.pipe';
import { SingleNamePipe } from './pipes/single-name.pipe';
import { TimeAfterPipe } from './pipes/time-after.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { MomentDatePipe } from './pipes/moment-date.pipe';
import { TimezoneNamePipe } from './pipes/timezone-name.pipe';
import { CkEditorDirective } from './directives/ck-editor.directive';
@NgModule({
    declarations: [
        DurationTimePipe,
        SingleNamePipe,
        TimeAfterPipe,
        SafeHtmlPipe,
        MomentDatePipe,
        TimezoneNamePipe,
        CkEditorDirective
    ],
    imports: [],
    exports: [
        DurationTimePipe,
        SingleNamePipe,
        TimeAfterPipe,
        SafeHtmlPipe,
        MomentDatePipe,
        TimezoneNamePipe,
        CkEditorDirective
    ]
})
export class CommonLibModule {}
